module.exports = __webpack_public_path__ + "static/media/cleaver.e6617b74.png";